import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { useGetAllPlanListQuery, useAddPlanMutation, useUpdatePlanMutation } from "slices/planApi";
import AddOrEditCouponForm from "../AddOrEditCouponForm";
import {
  Button,
} from '@mui/material';
import { useGetCouponsQuery } from "slices/common/couponSlice";
import { useDeleteCouponMutation } from "slices/common/couponSlice";
import { hasActionAccess } from "utility";
import { useSelector } from "react-redux";
function ServiceCoupons() {

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [open, setOpen] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [addPlan] = useAddPlanMutation();
  const [updatePlan] = useUpdatePlanMutation();
  const [del] = useDeleteCouponMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, error, refetch } = useGetCouponsQuery({ page, limit, search });

  const col = [
    { display: "Code", key: "code", type: "display" },
    { display: "Description", key: "description", type: "display" },
    { display: "Value", key: "discountValue", type: "display" },
    { display: "Type", key: "discountType", type: "display" },
    { display: "Minimum Value", key: "minimumOrderValue", type: "display" },
    { display: "Maximum Value", key: "maximumDiscount", type: "display" },
    { display: "Usage", key: "usageLimit", type: "display" },
    { display: "Valid From", key: "validFrom", type: "display" },
    { display: "Valid To", key: "validUntil", type: "display" },
    { display: "Used Count", key: "usedCount", type: "display" },

  ]

  const canEdit = hasActionAccess(auth, "Beauty App", "Services", "edit");
  const canDelete = hasActionAccess(auth, "Beauty App", "Services", "delete");

  col.push({
    display: "Actions",
    key: "edit",
    type: "action",
    render: (row) => (
      <>
        {canDelete && (
          <Button onClick={() => handleDelete(row._id)}>Delete</Button>
        )}
        {/* {canEdit && (
        <Button onClick={() => handleEdit(row)}>Edit</Button>
      )} */}
      </>
    ),
  });

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (p, l) => {
    setPage(p);
    setLimit(l);
  }

  const handleAdd = () => {
    setEditingPlan(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    console.log("row id===========>", id);
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      await del(id).unwrap();
      refetch();
    }
  }


  const handleEdit = (plan) => {
    setEditingPlan(plan);
    setOpen(true);
  };

  const handleSubmit = async (data) => {
    try {
      if (editingPlan) {
        await updatePlan(data).unwrap();
        refetch();
      } else {
        await addPlan(data).unwrap();
        refetch();
      }
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddOrEditCouponForm
        open={open}
        onClose={() => setOpen(false)}
        initialData={editingPlan}
        onSubmit={handleSubmit}
      />


      <Button onClick={handleAdd} style={{ background: "#fff" }}>Add Coupon</Button>

      <Tables
        title={"Alerts"}
        handleSearch={handleSearchChange}
        totalPages={data?.total}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={""}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ServiceCoupons;
